import React from "react";
import { LegalLayout, Section, CONTACT_EMAIL } from "../components/Legal";

const UL = ({ children }) => <ul className="list-disc pl-5 space-y-1">{children}</ul>;

export default function TermsOfService() {
  return (
    <LegalLayout title="Kullanım Koşulları" updated="16 Ekim 2026" testId="terms-page">
      <p>
        Bu koşullar, YZ Matematik'in (yzmatematik.com) kullanımını düzenler. Hizmeti kullanarak bu
        koşulları kabul etmiş olursunuz.
      </p>

      <Section title="1. Hizmetin tanımı">
        <p>
          YZ Matematik, LGS ve YKS (TYT/AYT) matematik hazırlığı için yapay zekâ destekli bir öğrenme
          platformudur. Platform, çözdüğünüz sorulara göre size uygun sorular seçer, ilerlemenizi gösterir
          ve çalışma önerileri sunar. Öğretmenler, onaylandıktan sonra sınıf oluşturup öğrencilerinin
          genel performansını görebilir.
        </p>
      </Section>

      <Section title="2. Hesaplar">
        <UL>
          <li>Hesabınızı e-posta ve şifre ile veya Google hesabınızla oluşturabilirsiniz.</li>
          <li>Hesap bilgilerinizin doğru olmasından ve şifrenizi gizli tutmaktan siz sorumlusunuz.</li>
          <li>Hesabınızda izinsiz bir kullanım fark ederseniz bize hemen bildirin.</li>
          <li>Öğretmen yetkisi, başvurunun yönetici tarafından onaylanmasıyla verilir; onaylanmamış başvurular öğretmen özelliklerine erişim sağlamaz.</li>
          <li>Reşit olmayan kullanıcıların hizmeti ebeveyn veya vasilerinin bilgisi dahilinde kullanmasını öneririz.</li>
        </UL>
      </Section>

      <Section title="3. Kabul edilebilir kullanım">
        <p>Hizmeti kullanırken şunları yapmamayı kabul edersiniz:</p>
        <UL>
          <li>Başka bir kişinin hesabına izinsiz erişmek veya erişmeye çalışmak,</li>
          <li>Hizmetin güvenliğini, işleyişini veya diğer kullanıcıların kullanımını bozmaya çalışmak,</li>
          <li>Soru içeriklerini toplu olarak kopyalamak, otomatik araçlarla çekmek veya izinsiz yeniden yayımlamak,</li>
          <li>Sınıf katılım kodlarını kötüye kullanmak ya da başka öğrencilerin verilerine erişmeye çalışmak,</li>
          <li>Hizmeti yasalara aykırı bir amaçla kullanmak.</li>
        </UL>
        <p>Bu kurallara uyulmaması hâlinde hesabınıza erişim kısıtlanabilir veya hesabınız kapatılabilir.</p>
      </Section>

      <Section title="4. Eğitim içeriği ve yapay zekâ">
        <p>
          Platformdaki sorular, çözümler, konu anlatımları ve öneriler yalnızca eğitim amaçlıdır. Bazı
          açıklamalar ve öneriler yapay zekâ ile üretilir. Yapay zekâ ile üretilen içerikler zaman zaman
          hatalı veya eksik olabilir; önemli konularda içeriği ders kitabınızla, öğretmeninizle veya resmî
          kaynaklarla karşılaştırarak kontrol etmenizi öneririz.
        </p>
        <p>
          YZ Matematik, sınav başarısı veya belirli bir puan için garanti vermez. Platformdaki başarı
          oranları ve öneriler, çözdüğünüz sorulara dayanan tahminlerdir.
        </p>
      </Section>

      <Section title="5. Fikrî haklar">
        <p>
          Platformdaki soru, çözüm, konu anlatımı, tasarım ve yazılım içerikleri izin alınmadan kopyalanamaz,
          çoğaltılamaz veya ticari amaçla kullanılamaz. Kişisel çalışma amacıyla kullanım serbesttir.
        </p>
      </Section>

      <Section title="6. Hizmetin sürekliliği">
        <p>
          Hizmeti kesintisiz ve hatasız sunmak için çalışırız; ancak bakım, güncelleme veya teknik sorunlar
          nedeniyle hizmet geçici olarak erişilemez olabilir. Hizmet olduğu gibi sunulur.
        </p>
      </Section>

      <Section title="7. Hizmette ve koşullarda değişiklik">
        <p>
          Hizmetin özelliklerini değiştirebilir, yeni özellikler ekleyebilir veya bazı özellikleri
          kaldırabiliriz. Bu koşullar da güncellenebilir; güncel sürüm her zaman bu sayfada yayımlanır ve
          üstteki tarih değiştirilir. Değişikliklerden sonra hizmeti kullanmaya devam etmeniz, güncel
          koşulları kabul ettiğiniz anlamına gelir.
        </p>
      </Section>

      <Section title="8. Hesabın kapatılması">
        <p>
          Hesabınızın kapatılmasını ve verilerinizin silinmesini istediğiniz zaman aşağıdaki adrese yazarak
          talep edebilirsiniz. Kişisel verilerin nasıl işlendiği <a className="text-[#007BFF] hover:underline" href="/privacy">Gizlilik Politikası</a>'nda açıklanmıştır.
        </p>
      </Section>

      <Section title="9. İletişim">
        <p>
          Hizmetle ilgili sorularınız için: <a className="text-[#007BFF] hover:underline" href={`mailto:${CONTACT_EMAIL}`} data-testid="terms-contact-email">{CONTACT_EMAIL}</a>
        </p>
      </Section>
    </LegalLayout>
  );
}
